import React, { Component } from "react";
import { Link } from "react-router-dom";
import Logo from "../Component/WhatsApp Image 2025-11-03 at 14.49.12_c1fd7792.jpg";
import "./Navbar.css";

class Navbar extends Component {
  state = { 
    clicked: false, 
    openDropdown: null,
    isMobile: window.innerWidth <= 991 
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('popstate', this.closeMenu);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('popstate', this.closeMenu);
  }

  handleResize = () => {
    const isMobile = window.innerWidth <= 991;
    if (this.state.isMobile !== isMobile) {
      this.setState({ isMobile, clicked: false, openDropdown: null });
    }
  };

  handleClick = () => {
    this.setState(prevState => ({ 
      clicked: !prevState.clicked, 
      openDropdown: null 
    }));
  };

  toggleDropdown = (menu) => {
    if (this.state.isMobile) {
      this.setState(prevState => ({
        openDropdown: prevState.openDropdown === menu ? null : menu,
      }));
    }
  };

  closeMenu = () => {
    this.setState({ clicked: false, openDropdown: null });
  };

  componentDidUpdate(_, prevState) {
    if (this.state.clicked !== prevState.clicked) {
      document.body.classList.toggle("menu-open", this.state.clicked);
    }
  }

  handleLogout = () => {
    const { onLogout } = this.props;
    if (onLogout) {
      onLogout();
    }
    this.closeMenu();
    // Navigate to home page after logout
    window.location.href = '/';
  };

  render() {
    const { clicked, openDropdown } = this.state;
    const { onLoginClick, isLoggedIn } = this.props;
    
    return (
      <>
        <nav className="navbar fixed-top bg-white shadow-sm">
          <div className="container d-flex align-items-center justify-content-between">

            {/* LOGO */}
            <div className="CPIT-logo-div">
              <Link to="/" onClick={this.closeMenu}>
                <img src={Logo} className="logo-CPIT img-fluid" alt="CPIT Logo" />
              </Link>
            </div>

            {/* NAVIGATION */}
            <ul id="nav" className={clicked ? "active nav-list" : "nav-list"}>
              <li className="nav-items">
                <Link to="/" onClick={this.closeMenu}>Home</Link>
              </li>

              <li className="nav-items dropdown">
                <button className="dropdown-toggle" onClick={() => this.toggleDropdown("about")}>About</button>
                <ul className={`dropdown-menu ${openDropdown === "about" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="/about-cpit" onClick={this.closeMenu}>About CPIT</Link></li>
                  <li><Link className="dropdown-item" to="/director-message" onClick={this.closeMenu}>Director Message</Link></li>
                  <li><Link className="dropdown-item" to="/instructorPage" onClick={this.closeMenu}>Instructor</Link></li>
                  <li><Link className="dropdown-item" to="/testimonialPage" onClick={this.closeMenu}>Testimonial</Link></li>
                </ul>
              </li>

              <li className="nav-items">
                <Link to="/coursesPage" onClick={this.closeMenu}>Courses</Link>
              </li>

              <li className="nav-items dropdown">
                <button className="dropdown-toggle" onClick={() => this.toggleDropdown("projects")}>Projects</button>
                <ul className={`dropdown-menu ${openDropdown === "projects" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="/nielit" onClick={this.closeMenu}>NIELIT</Link></li>
                  <li><Link className="dropdown-item" to="/upsdm" onClick={this.closeMenu}>UPSDM</Link></li>
                  <li><Link className="dropdown-item" to="/bsdm" onClick={this.closeMenu}>BSDM</Link></li>
                  <li><Link className="dropdown-item" to="/asdc" onClick={this.closeMenu}>ASDC</Link></li>
                  <li><Link className="dropdown-item" to="/pmkvy" onClick={this.closeMenu}>PMKVY</Link></li>
                  <li><Link className="dropdown-item" to="/csr" onClick={this.closeMenu}>CSR</Link></li>
                  <li><Link className="dropdown-item" to="/ddugky" onClick={this.closeMenu}>DDUGKY</Link></li>
                  <li><Link className="dropdown-item" to="/ttsc" onClick={this.closeMenu}>TSSC</Link></li>
                  <li><Link className="dropdown-item" to="/ncvte" onClick={this.closeMenu}>NCVTE</Link></li>
                </ul>
              </li>

              <li className="nav-items">
                <Link to="/contactPage" onClick={this.closeMenu}>Contact</Link>
              </li>

              <li className="nav-items">
                <Link to="/gallery" onClick={this.closeMenu}>Gallery</Link>
              </li>

              <li className="nav-items">
                <Link to="/AwardsRecognition" onClick={this.closeMenu}>Awards & Recognition</Link>
              </li>

              <li className="nav-items dropdown">
                <button className="dropdown-toggle" onClick={() => this.toggleDropdown("social")}>Social Activity</button>
                <ul className={`dropdown-menu ${openDropdown === "social" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="/covid" onClick={this.closeMenu}>Covid 19</Link></li>
                  <li><Link className="dropdown-item" to="/SocialWork" onClick={this.closeMenu}>Social Work</Link></li>
                  <li><Link className="dropdown-item" to="/SocialAwareness" onClick={this.closeMenu}>Social Awareness</Link></li>
                  <li><Link className="dropdown-item" to="/environmentalAwareness" onClick={this.closeMenu}>Environment Awareness</Link></li>
                  <li><Link className="dropdown-item" to="/HarGharTiranga" onClick={this.closeMenu}>Har Ghar Tiranga</Link></li>
                </ul>
              </li>

              <li className="nav-items dropdown">
                <button className="dropdown-toggle" onClick={() => this.toggleDropdown("download")}>Download</button>
                <ul className={`dropdown-menu ${openDropdown === "download" ? "show" : ""}`}>
                  <li><Link className="dropdown-item" to="/student-corner" onClick={this.closeMenu}>Student Corner</Link></li>
                  <li><Link className="dropdown-item" to="/result" onClick={this.closeMenu}>Result</Link></li>
                  <li><Link className="dropdown-item" to="/DownloadForm" onClick={this.closeMenu}>Download Form</Link></li>
                </ul>
              </li>
            </ul>

            {/* DONATION BUTTON */}
            <div className="donation-btn-div">
              <Link to="/Donation" className="donation-btn" onClick={this.closeMenu}>
                Donation
              </Link>
            </div>

            {/* CONDITIONAL LOGIN/LOGOUT BUTTON */}
            <div className="login-btn-div">
              {isLoggedIn ? (
                <button className="logout-btn" onClick={this.handleLogout}>
                  Logout
                </button>
              ) : (
                <button className="login-btn" onClick={onLoginClick}>
                  Login
                </button>
              )}
            </div>

            {/* MOBILE MENU TOGGLER */}
            <div id="mobile" onClick={this.handleClick}>
              <i id="bar" className={clicked ? "fa-solid fa-xmark" : "fa-solid fa-bars"}></i>
            </div>
          </div>
        </nav>

        {/* MOBILE OVERLAY */}
        {clicked && <div className="menu-overlay" onClick={this.closeMenu}></div>}
      </>
    );
  }
}

export default Navbar;